var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a5e52e41e87dc4415428124adb5ac673ab1e272e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hem-com@hem-design-studio"]={id:"a5e52e41e87dc4415428124adb5ac673ab1e272e"};
      